<template>
  <div>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="客户资源" name="first" v-if="isAdmin"></el-tab-pane>
      <el-tab-pane label="分配情况" name="second" v-if="isAdmin"></el-tab-pane>
      <el-tab-pane label="我的任务" name="third" v-if="isStaff"></el-tab-pane>
    </el-tabs>
    <CustomerResources
      v-if="activeName === 'first' && isAdmin"
    ></CustomerResources>
    <AllocationSituation
      v-if="activeName === 'second' && isAdmin"
    ></AllocationSituation>
    <MyTasks v-if="activeName === 'third' && isStaff"></MyTasks>
    <el-empty
        v-if="!isAdmin&& !isStaff"
        :image-size="400"
        description="您暂无权限查看，请联系管理员增加权限"
      ></el-empty>
  </div>
</template>

<script>
import CustomerResources from "./batchAddFriends/customerResources.vue";
import AllocationSituation from "./batchAddFriends/allocationSituation.vue";
import MyTasks from "./batchAddFriends/myTasks.vue";
export default {
  name: "addFriends",
  components: { CustomerResources, AllocationSituation, MyTasks },
  data() {
    return {
      activeName: "first",
      isStaff: false,
      isAdmin: false,
      // list: this.$store.state.tagsView.routerList,
      list: JSON.parse(localStorage.getItem("routerList")),
      flatList: [],
    };
  },
  created() {
    this.handleLimits();
  },
  methods: {
    handleLimits() {
      this.handleFlat(JSON.parse(localStorage.getItem("routerList")));
      console.log("---------", this.flatList);
      let arrList = this.$store.state.tagsView.roleAuthrority;
      this.flatList.forEach((item) => {
        if (item.menuId == "80") {
          this.isAdmin = true;
        }
        if (item.menuId == "84") {
          this.isStaff = true;
          if (!this.isAdmin) {
            this.activeName = "third";
          }
        }
      });
    },
    handleFlat(list) {
      list.forEach((item) => {
        if (item.menus.length <= 0) {
          this.flatList.push({ menuName: item.menuName, menuId: item.menuId });
        } else {
          this.handleFlat(item.menus);
        }
      });
    },
    handleClick() {},
  },
};
</script>
